// 供应商发货指令
export default {
  // 发货指令列表查询
  GET_DATA_API: '/warehouse/shippingInstruction/listShippingInstructionV2ByPage',
  //发货指令保存/提交物流/生成业务入库单
  SAVE_DATA_API: '/warehouse/shippingInstruction/saveShippingInstructionV2',
  //查看发货指令详情
  DETAIL_DATA_API: '/warehouse/shippingInstruction/getShippingInstruction/',
  // 发货指令复制
  COPY_DETAIL_DATA_API: '/warehouse/shippingInstruction/copy/',
  //撤回发货指令
  BACK_OUT_API: '/warehouse/shippingInstruction/updateShippingInstructionBackout',
  //删除发货指令
  DEL_DATA_API: '/warehouse/shippingInstruction/deleteShippingInstruction',
  //新增附件
  ADD_ATTACH_API: '/warehouse/attachment/saveStorageAttachment',
  //删除附件
  DEL_ATTACH_API: '/warehouse/attachment/deleteStorageAttachment',
  //删除附件
  SAVE_TRANSPORT_API: '/warehouse/shippingInstruction/saveTransportation',
  //附件列表
  GET_ATTACH_API: '/warehouse/attachment/listStorageAttachmentByPage',
  // //获取新的发货指令编码
  // 'GET_NEWNO_API': '/warehouse/shippingInstruction/getNewInstructionNo',
  //获取剩余数量
  GET_REMAINNUMBER_API: '/warehouse/shippingInstruction/getRemainingNumber',
  GET_EXIT_REST_INBOUND: '/warehouse/businessInbound/getExitRestInboundQuantityByContractNo',
  // 获取字典表
  DATA_DICT: '/maindata/dictData/listDataDictByDataType',
  //获取采购合同列表
  LIST_ORDER_API: '/sales/order/listOrderByPage',
  //弹窗
  LIST_DETAIL: '/sales/orderDetail/listOrderDetailByPage',
  //获取采购合同详情
  DETAIL_ORDER_API: '/sales/order/getOrder',
  //计算价格
  CALC_AMOUNT_API: '/sales/orderSalesReturn/getReturnMoneyAmount',
  //货币种类接口
  LIST_CURRENCY: '/maindata/currency/listCurrency',
  // 根据指令类型 确认仓库
  CHECK_WAREHOUSE_BELONG_API: '/maindata/storage/getStorageDetail/',
  /** 仓库列表 */
  STORAGE_LIST_API: '/maindata/storage/listStorageByPage',
  /**校验是否可以提单*/
  CHECK_ORDER_API: '/sales/order/checkLadingQuantity',
  /**校验是否可以创建供应商发货指令*/
  CHECK_SHIPPING_API: '/sales/order/checkShippingInstruction',

  // ============ sunxueping 添加批量导入 ============
  IMPORT_SHIPPINGINSTRUCTION: '/warehouse/shippingInstruction/importExcel',
  // ================================================
  // ============ sunxueping 添加导出 ============
  EXPORT_SHIPPINGINSTRUCTION: '/warehouse/shippingInstruction/exportShippingInstructionExcel',
  // ================================================
  //获取合作伙伴联系人信息
  GET_PARTNER_PERSON: '/maindata/partners/getPartnerPersonInfo',

  /**打印查询 */
  GET_FILE: '/maindata/dict/getFileTemplate',
  /**打印或下载 */
  EXPORT_PRINT: '/sales/shippingInstruction/exportPrint',

  //根据合同创建发货指令、
  CREATE_SHIPPING_INSTRUCTION: '/sales/order/createShippingInstruction',
  // 查询关联供应商的业务公司
  LIST_RELATE_COMPANY: '/maindata/company/listCompanyDepartmentTree',
  /** 获取集团内部关联和客户供应商公司列表 */
  PARTNER_LIST_API: '/maindata/partners/listPartner',
  // 获取基地下拉数据
  CUSTOMER_ADDRESS: '/sales/order/getCustomerAddressInfo',
  // 批量删除数据
  BATCH_DELETE: '/warehouse/shippingInstruction/deleteBatchByDetailIds',
  // 打印接口
  PRINT_API: 'warehouse/shippingInstruction/print',
  // 冲销
  WRITE_OFF_API: '/warehouse/shippingInstruction/writeOff',
};
